import React from "react";
import DSBox from "../../system-design/DSBox";
import DSTypography from "../../system-design/DSTypography";
import { Info } from "@mui/icons-material";

const PriorityExplanationBox = () => {
  return (
    <DSBox
      sx={{
        mb: 3,
        p: 2,
        backgroundColor: "#e3f2fd",
        borderRadius: 2,
        border: "1px solid #90caf9",
      }}
    >
      <DSBox
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          mb: 1,
        }}
      >
        <Info color="info" />
        <DSTypography variant="body2" fontWeight="bold">
          Personal Feed Priority Rules
        </DSTypography>
      </DSBox>
      <DSTypography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Events are prioritized by their type. Lower priority numbers rank
        higher:
      </DSTypography>
      <DSBox sx={{ pl: 2 }}>
        <DSTypography variant="body2" sx={{ mb: 0.5 }}>
          • <strong>PRIMARY (1-15):</strong> National/Federal holidays - highest
          priority
        </DSTypography>
        <DSTypography variant="body2" sx={{ mb: 0.5 }}>
          • <strong>SECONDARY (15-40):</strong> State/Regional holidays
        </DSTypography>
        <DSTypography variant="body2" sx={{ mb: 0.5 }}>
          • <strong>LOCAL (55-70):</strong> Municipal/limited scope holidays
        </DSTypography>
        <DSTypography variant="body2" sx={{ mb: 0.5 }}>
          • <strong>OBSERVANCES (41-90):</strong> Cultural observances
        </DSTypography>
        <DSTypography variant="body2" sx={{ mb: 1 }}>
          • <strong>OTHER (91+):</strong> Miscellaneous events
        </DSTypography>
        <DSTypography
          variant="body2"
          sx={{ fontStyle: "italic", color: "primary.main" }}
        >
          When multiple events have the SAME priority number, ALL are selected
          for the personal feed.
        </DSTypography>
      </DSBox>
    </DSBox>
  );
};

export default PriorityExplanationBox;
